export const COMMUNITY_SORT_OPTIONS = [
  { label: 'Newest', value: 'newest' },
  { label: 'Most Liked', value: 'likes' },
  { label: 'Most Commented', value: 'comments' },
] as const;

type SortOptionValue = (typeof COMMUNITY_SORT_OPTIONS)[number]['value'];

export type SortOption = SortOptionValue;

export const sortOptionMap = new Map(COMMUNITY_SORT_OPTIONS.map((opt) => [opt.value, opt]));
